import React, { useState } from 'react';

export const TabsPreview = ({ component, onClick, isSelected }) => {
  const { commonAttrs, specificAttrs } = component;
  const { tabs } = specificAttrs || {};
  const [activeTab, setActiveTab] = useState(0);
  const tabsArray = (tabs || 'Tab 1,Tab 2,Tab 3').split(',');
  
  const containerStyle = {
    padding: `${commonAttrs?.paddingTop || 16}px ${commonAttrs?.paddingRight || 16}px ${commonAttrs?.paddingBottom || 16}px ${commonAttrs?.paddingLeft || 16}px`,
    margin: `${commonAttrs?.marginTop || 8}px ${commonAttrs?.marginRight || 0}px ${commonAttrs?.marginBottom || 8}px ${commonAttrs?.marginLeft || 0}px`,
    width: commonAttrs?.width === 'auto' ? 'auto' : `${commonAttrs?.width || 100}%`,
    cursor: onClick ? 'pointer' : 'default',
    border: isSelected ? '2px solid #3B82F6' : '2px solid transparent',
    borderRadius: '4px'
  };
  
  return (
    <div style={containerStyle} onClick={onClick}>
      <div>
      <div style={{ display: 'flex', borderBottom: '2px solid #E5E7EB', gap: '4px' }}>
        {tabsArray.map((tab, idx) => (
          <button
            key={idx}
            onClick={() => setActiveTab(idx)}
            style={{
              padding: '8px 16px',
              background: activeTab === idx ? '#3B82F6' : 'transparent',
              color: activeTab === idx ? '#FFFFFF' : '#6B7280',
              border: 'none',
              borderRadius: '4px 4px 0 0',
              fontSize: '14px',
              fontWeight: activeTab === idx ? '600' : '400',
              cursor: 'pointer'
            }}
          >
            {tab.trim()}
          </button>
        ))}
      </div>
      <div style={{ padding: '16px', background: '#F9FAFB', minHeight: '80px' }}>
        Content for {tabsArray[activeTab]?.trim()}
      </div>
      </div>
    </div>
  );
};
